module.exports = __webpack_public_path__ + "img/gjz.7918246.png";